export enum Context {
    CallForProposal,
    SpeakerProfile,
    TShirtDesignContest
}
